import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

import { environment } from '@environment';
import { DateTransformPipe } from '@app/pipes/date-format.pipe';
import { PlaceNamePipe } from '@app/pipes/place-name.pipe';
import { mapRecentAutoSearchData } from '@search-bar/mappers/url-search.mapper';
import { SearchParamFromType } from '@search-bar/entities/search-type';
import { RecentCarsLocationType, RecentSearchCars } from '@recent-searches/entities/recent-search';
import { RecentSearchBaseComponent } from '@recent-searches/components/recent-search-base.component';

@Component({
  selector: 'app-cars-recent-search',
  templateUrl: './cars-recent-search.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CarsRecentSearchComponent extends RecentSearchBaseComponent {

  constructor(
    protected router: Router,
    protected datePipe: DatePipe,
    protected dateTransformPipe: DateTransformPipe,
    protected placeNamePipe: PlaceNamePipe,
    protected changeDetector: ChangeDetectorRef
  ) {
    super(router, datePipe, dateTransformPipe, placeNamePipe, changeDetector);
  }

  get carsSearch(): RecentSearchCars {
    return this.search as RecentSearchCars;
  }

  get istypeLatLong(): boolean {
    return this.carsSearch?.dropoff?.type === RecentCarsLocationType.LatLon;
  }

  public searchAutos(): void {
    const _search = {
      ...this.carsSearch,
      dropoff: {
        ...this.carsSearch?.dropoff,
        time: this.formatDateBySearch(this.carsSearch?.dropoff?.time)
      },
      pickup: {
        ...this.carsSearch?.pickup,
        time: this.formatDateBySearch(this.carsSearch?.pickup?.time)
      }
    };
    const urlParams = mapRecentAutoSearchData(_search);
    this.router.navigate(
      [`${urlParams}`],
      {
        queryParams: {
          source: SearchParamFromType.RECENT,
          branch_code: _search?.branch_code ? _search.branch_code : environment.branchcode,
          from: SearchParamFromType.RECENT
        }
      }
    );
  }
}
